import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import logo from "../assets/tech.png";
import { FaFacebookF, FaInstagram, FaWhatsapp, FaGoogle } from "react-icons/fa";

export default function Footer() {

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  return (
    <footer className="footer">

      <div className="footer-glow" />

      <div className="container">

        <div className="footer-top">

          {/* BRAND */}
          <div className="footer-brand">

            <div className="footer-logo">
              <img
                src={logo}
                alt="Digital Media Solution Digital Marketing Agency Mumbai"
                className="footer-logo-img"
              />
            </div>

            <p>
              Digital Media Solution is a leading <strong>Digital Marketing Agency in Mumbai </strong>
              providing SEO services, Social Media Marketing, Google Ads,
              Website Design and lead generation services in Mumbai, Virar
              and across India.
            </p>

            <div className="footer-socials">

              <a href="https://www.facebook.com/dmstechnologies"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="social-btn"
                 aria-label="Facebook">
                <FaFacebookF />
              </a>

              <a href="https://www.instagram.com/dms_technologies/"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="social-btn"
                 aria-label="Instagram">
                <FaInstagram />
              </a>

              <a href="https://wa.me/919370115694"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="social-btn"
                 aria-label="WhatsApp">
                <FaWhatsapp />
              </a>

              <a href="https://share.google/b2XElxUDz7fwlsfpW"
                 target="_blank"
                 rel="noopener noreferrer"
                 className="social-btn"
                 aria-label="Google Business">
                <FaGoogle />
              </a>

            </div>
          </div>


          {/* DIGITAL MARKETING SERVICES */}
          <div className="footer-col">
            <h4>Digital Marketing Services</h4>

            <Link to="/services/social-media-marketing" onClick={scrollToTop}>
              Social Media Marketing Mumbai
            </Link>

            <Link to="/services/social-media-optimization" onClick={scrollToTop}>
              Social Media Optimization Mumbai
            </Link>

            <Link to="/services/whatsapp-marketing" onClick={scrollToTop}>
              WhatsApp Marketing Services
            </Link>

            <Link to="/services/google-ads" onClick={scrollToTop}>
              Google Ads Agency Mumbai
            </Link>

            <Link to="/services/meta-ads" onClick={scrollToTop}>
              Meta Ads Agency Mumbai
            </Link>
          </div>


          {/* WEBSITE SERVICES */}
          <div className="footer-col">

            <h4>Website Development</h4>

            <Link to="/services/website-design" onClick={scrollToTop}>
              Website Design Company Mumbai
            </Link>

            <Link to="/services/website-development" onClick={scrollToTop}>
              Website Development Services
            </Link>

            <Link to="/services/domain-hosting" onClick={scrollToTop}>
              Domain & Hosting Services
            </Link>

            <Link to="/services/website-maintenance" onClick={scrollToTop}>
              Website Maintenance Services
            </Link>

            <Link to="/services/ecommerce-development" onClick={scrollToTop}>
              E-Commerce Website Development
            </Link>

            <Link to="/services/graphic-design" onClick={scrollToTop}>
              Graphic Design Services
            </Link>

          </div>


          {/* CONTACT / LOCATION */}
          <div className="footer-col">

            <h4>Contact Us</h4>

            <p className="footer-address">
              Digital Marketing Agency in Mumbai <br />
              01, MV Plaza, Above ICICI Bank, <br />
              Manvelpada Rd, Virar East, Maharashtra 401305
            </p>

            <a href="mailto:info@dmstechnologies.in">
              info@dmstechnologies.in
            </a>

            <a href="tel:+919370115694">
              +91 93701 15694
            </a>

            <Link to="/about" onClick={scrollToTop}>
              About Digital Media Solution
            </Link>

            <Link to="/about/team" onClick={scrollToTop}>
              Our Team
            </Link>

          </div>

        </div>


        {/* BOTTOM */}
        <div className="footer-bottom">

          <p>
            © 2026 <strong>Digital Media Solution</strong> –
            Digital Marketing Agency in Mumbai |
            Website Development Expert Mumbai |
            Social Media Marketing Mumbai
          </p>

        </div>

      </div>

    </footer>
  );
}